import React, { Component } from 'react';
import { withFirebase } from '../../../utils/Firebase';

import CampaignList from './CampaignList';
import './Campaigns.scss';

import Loading from '../../atoms/Loading';

const url = `https://sheets.googleapis.com/v4/spreadsheets/1-NpsjALm7kMt_b6egdy29A3lQmT3FgN_UOtBXQwCdok/values:batchGet?ranges=Sheet1&majorDimension=ROWS&key=AIzaSyBJIbU-hSgxUuhk-Ug_RgqX07D_15pzVVY`;

class Campaigns extends Component {

  constructor(props) {
    super(props);
    this.state = {
      items: null,
      loading: true,
      spend: 0,
      impressions: 0,
      clicks: 0,
      WebsiteConversions: 0,
    };
  }

  componentDidMount() {
    fetch(url).then(response => response.json()).then(data => {
      let batchRowValues = data.valueRanges[0].values;
 
      const rows = [];
      for (let i = 1; i < batchRowValues.length; i++) {
        let rowObject = {};
        for (let j = 0; j < batchRowValues[i].length; j++) {
          rowObject[batchRowValues[0][j]] = batchRowValues[i][j];
        }
        rows.push(rowObject);
      }
      
      // this.setState({ items: rows }, () => this.getData('2018'));
      this.setState({ items: rows });

      this.setState({ loading: false });

      // Spend
      let cost = rows.reduce((s, f) => {
        return s + parseInt(f.Cost);               // return the sum of the accumulator and the current time, as the the new accumulator
    }, 0); 
    this.setState({ spend: cost });

    // impressions
    let impressions = rows.reduce((i, f) => {
        return i + parseInt(f.Impressions);               // return the sum of the accumulator and the current time, as the the new accumulator
    }, 0); 
    this.setState({ impressions: impressions });

    // Clicks
    let clicks = rows.reduce((c, f) => {
        return c + parseInt(f.Linkclicks);               // return the sum of the accumulator and the current time, as the the new accumulator
    }, 0); 
    this.setState({ clicks: clicks });

    // WebsiteConversions
    let conv = rows.reduce((wc, f) => {
        return wc + parseInt(f.WebsiteConversions);               // return the sum of the accumulator and the current time, as the the new accumulator
    }, 0); 
    this.setState({ WebsiteConversions: conv });


    });
    
  }



  render() {

    const { items, loading, spend, impressions, clicks, WebsiteConversions } = this.state;

    if (loading) return <Loading />;
  

    return (
      <div className="container">

<div className="row">
      <div className="col-12">
        <h1>Live Campaigns</h1>
     </div>
</div>

        <div className="row">

<div className="col-3">
  <div className="card">
  <h3>Spend: £{spend}</h3>
  </div>
</div>

<div className="col-3">
  <div className="card">
  <h3>impressions: {impressions}</h3>
  </div>
</div>

<div className="col-3">
  <div className="card">
  <h3>Clicks: {clicks}</h3>
  </div>
</div>

<div className="col-3">
  <div className="card">
  <h3>Web Conv: {WebsiteConversions}</h3>
  </div>
</div>



        </div>


<div className="row">
      <div className="col-12">

        <div className="card">
          <div className="liveCampaigns">

              <p>Actual Live Campaigns from THE OUT, Supermetrics google sheet</p>
              <CampaignList data={items} title="THE OUT | LIVE | AD Level"/>
            
          </div>
        </div>
        </div>
</div>

      </div>
    );
  }
}

export default withFirebase(Campaigns);
